/*eslint-disable*/
// Closure
(function() {
  /**
   * Decimal adjustment of a number.
   *
   * @param {String}  type  The type of adjustment.
   * @param {Number}  value The number.
   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
   * @returns {Number} The adjusted value.
   */
  function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (value == null || isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // If the value is negative...
    if (value < 0) {
      return -decimalAdjust(type, -value, exp);
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

  // Decimal round
  if (!Math.round10) {
    Math.round10 = function(value, exp) {
      return decimalAdjust('round', value, exp);
    };
  }
  // Decimal floor
  if (!Math.floor10) {
    Math.floor10 = function(value, exp) {
      return decimalAdjust('floor', value, exp);
    };
  }
  // Decimal ceil
  if (!Math.ceil10) {
    Math.ceil10 = function(value, exp) {
      return decimalAdjust('ceil', value, exp);
    };
  }
})();

var Location = {
  pickers: [],
  autocompleteReady: false,
  autoPickers: [],
  maps: [],
  browserCalled: false,

  update: function(scope, data, fromPicker) {
    if (typeof fromPicker === 'undefined' || fromPicker == null) {
      fromPicker = false;
    }

    if ((data.zip === null || data.zip.length < 1) && data.location !== null) {
      Location._getLocationFromGeo(data.location, function(d) {
        Location.update(scope, d);
      });
      return;
    }

    if (data.zip === null || data.zip.length < 1) {
      data = null;
    }

    if (scope == 'global') {
      this._updateLocationData(data);
    }

    var triggerData =  {scope: scope, data: data, picker: false};
    if (fromPicker) {
      triggerData['picker'] = true;
    }

    jQuery('[data-location-scope-id=' + scope + ']').each(function() {
      jQuery(this).trigger('location-update', triggerData);
    });
  },

  getGlobal: function() {
    var location = localStorage.getItem('location');
    if (!location) {
      return null;
    }

    return JSON.parse(location);
  },

  getPickers: function() {
    return this.pickers;
  },

  determineGlobalFromBrowser: function(func) {
    if (this.browserCalled) {
      return;
    }

    this.browserCalled = true;

    navigator.geolocation.getCurrentPosition(function(position) {
      Location._getLocationFromGeo(position, func);
    }, function(error) {
      // TODO document why this function is empty
    });
  },

  _getLocationFromGeo: function(position, func) {
    var coords = [
      Math.round10(position.coords.latitude, -8),
      Math.round10(position.coords.longitude, -8)
    ];

    var url = '/spire_location/geocode.json?latlng=' + coords[0] + ',' + coords[1];
    jQuery.ajax({url: url}).done(function (data) {
      if (typeof data.error_message != 'undefined') {
        // TODO document why this block is empty 
      }
      else {
        var address = Location._getLocationFromComponents(Location.extractAddressComp(data.results));
        address.location = position;
        func(address);
      }
    });
  },

  extractAddressComp: function(addresses) {
      var address = null;
      if(addresses && addresses.length > 0) {
        address = addresses.find(function(item) {
          var addressComp = Location.findZipCode(item.address_components);
          // If found then return the element
          return addressComp && addressComp.length > 0;
        });

        // Otherwise set default value as the first element
        if(!address) {
          const dumpZip = "65811";
          address = addresses[0].address_components;
          address.push({"long_name": dumpZip, "short_name": dumpZip, "types": ['postal_code']});
        }
      }
      return address?.address_components;
  },

  findZipCode: function(address_components) {
     if(address_components && address_components.length > 0) {
       return address_components.filter(function(component) {
         const addressType = component.types[0];
         if (addressType === 'postal_code') {
           return component;
         }
       });
     }
     return [];
  },

  registerMap: function(map) {
    this.maps.push(map);
    this.setupMaps();
  },

  setupMaps: function() {
    if (this.autocompleteReady === true) {
      
      for (var map of this.maps) {
        if (map.attr('data-map-setup') != undefined) {
          continue;
        }
        map.attr('data-map-setup', true);
        map.trigger('google-maps-init', {});
      }
    }
  },

  addPicker: function(picker) {
    this.pickers.push(picker);
    this.setupPickers();
  },

  setupPickers: function() {
    if (this.autocompleteReady === true) {
      var today = new Date();
      var milliseconds = today.getMilliseconds()

      for (var picker of this.pickers) {
        if (picker.attr('data-updated-time') != undefined) {
          continue;
        }
        picker.attr('data-updated-time', milliseconds);
        picker.attr('data-changed-time', milliseconds);

        picker.on('change', function() {
          var todayDate = new Date();
          var milliSeconds = todayDate.getMilliseconds();

          jQuery(this).attr('data-changed-time', milliSeconds);
        });

        this._addUpdatePicker(picker);
      }
    }
  },

  _addUpdatePicker: function(picker) {
    var autocomplete = new google.maps.places.Autocomplete(
      /** @type {!HTMLInputElement} */(picker[0]),
      {types: ['geocode']});

    google.maps.event.addListener(autocomplete, 'place_changed', function() {
      Location.updateAddress(autocomplete, picker);
    });
    this.autoPickers.push({autocomplete: autocomplete, picker: picker});
  },

  updateAddress: function(autocomplete, picker) {
    var scope = picker.attr('data-location-scope-id');
    var data = this._getLocationFromUpdate(autocomplete);

    this.update(scope, data, true);
  },

  _getLocationFromUpdate: function(update) {
    var place = update.getPlace();
    return this._getLocationFromComponents(place.address_components, place);
  },

  _getLocationFromComponents: function(components, place) {
    var zip = null;
    var city = null;
    var state = null;
    var state_abr = null;
    var location = { coords: {} };

    for (var component of components) {
      var addressType = component.types[0];
      if (addressType === 'postal_code') {
        zip = component['long_name'];
      }
      else if (addressType === 'locality') {
        city = component['long_name'];
      }
      else if (addressType === 'administrative_area_level_1') {
        state = component['long_name'];
        state_abr = component['short_name'];
      }
    }

    if (place) {
      location.coords.latitude = place.geometry.location.lat();
      location.coords.longitude = place.geometry.location.lng();
    }

    return {zip: zip, city: city, state: state, state_abr: state_abr, location: location };
  },

  _updateLocationData: function(data){
    if (data === null || !data.zip === null || data.zip.length < 1) {
      localStorage.setItem('location', null);
    }
    localStorage.setItem('location', JSON.stringify(data));
  },

  _updateGlobal: function(data) {
    if (data === null || !data.zip === null || data.zip.length < 1) {
      localStorage.setItem('location', null);
    }
    localStorage.setItem('location', JSON.stringify(data));
    GlobalLocationHeader.init($(this));
  }
};


function fillInAddress2() {
  Location.updateAddress();
}

function initGoogleMapsReal() {
  Location.autocompleteReady = true;
  Location.setupPickers();
  Location.setupMaps();
}
